/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesPlayGameIframeGameConfigOptions interface.
 */
export function instanceOfFxIdWebFeaturesPlayGameIframeGameConfigOptions(value) {
    if (!('IframeUrl' in value) || value['IframeUrl'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesPlayGameIframeGameConfigOptionsFromJSON(json) {
    return FxIdWebFeaturesPlayGameIframeGameConfigOptionsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameIframeGameConfigOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'IframeUrl': json['IframeUrl'],
    };
}
export function FxIdWebFeaturesPlayGameIframeGameConfigOptionsToJSON(json) {
    return FxIdWebFeaturesPlayGameIframeGameConfigOptionsToJSONTyped(json, false);
}
export function FxIdWebFeaturesPlayGameIframeGameConfigOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'IframeUrl': value['IframeUrl'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesPlayGameIframeGameConfigOptions.js.map